<template>
    <div class="container">
        <div :class="isDouble?'biserial':'single_row'" v-for=" (item,index) in  imageList" :key="index">
            <img class="img" v-lazy="item" />
        </div>
    </div>
</template>
<script>
// import config from '@/config'
export default {
  props: {
    isDouble: Boolean,
    imageList: Array
  },
  data() {
    return {
    };
  },
  methods: {
  },
  created() {
  }
}

</script>
<style lang="less" rel="stylesheet/less" scoped>
    @import "index";
</style>
